$('.js-input').keyup(function () {
    if ($(this).val()) {
        $(this).addClass('not-empty');
    } else {
        $(this).removeClass('not-empty');
    }
});

$('.gform_fields input[type="text"], .gform_fields textarea').focus(function() {
	$(this).parents('.gfield').addClass('active');
})

$('.gform_fields input[type="text"], .gform_fields textarea').blur(function() {
	var $this = $(this);

	if($this.val() == '') {
		$(this).parents('.gfield').removeClass('active');
	}
})


$(function () {
    $('input').focusout(function () {
        var text_val = $(this).val();
        $(this).parents('.gfield').toggleClass('active', text_val !== "");
    }).focusout();
});